import React, { useCallback } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { Button, useTranslate } from "react-admin";
import { DriverLogDetailedView } from "../../../../common/data/service-proxies";
import "./DriverLogExceptionsView.css";
import { DriverLogExceptionViewRow } from "./DriverLogExceptionViewRow";
import AddIcon from "@material-ui/icons/Add";
import { useHistory } from "react-router";
import resourceNames from "../../../../common/data/resourceNames";
import { useActionPermissions } from "../../../../common/auth/useActionPermissions";
import permissionNames from "../../../../common/auth/access-control/permissionNames";

interface Props {
  record: DriverLogDetailedView;
}

export const DriverLogExceptionsView = ({ record }: Props) => {
  const translate = useTranslate();
  const history = useHistory();
  const permissions = useActionPermissions();

  const handleAddExceptionClick = useCallback(() => {
    history.push(
      `/${resourceNames.HOS_DRIVER_LOG_VIEW}/${record.driverId}/${record.date}/addException`,
      {
        record: {
          driverId: record.driverId!,
          date: record.date,
        },
      }
    );
  }, [history, record.date, record.driverId]);

  return (
    <div id="driver-log-exceptions-container">
      <div className="exceptions-grid-header">
        <Typography variant="h6">
          {translate("resources.hos-driver-log-view.labels.exceptions")}
        </Typography>
        <div className="exceptions-grid-buttons">
          {permissions && permissions[permissionNames.hos.logs.addException] ? (
            <Button
              label="resources.hos-driver-log-view.labels.addException"
              onClick={handleAddExceptionClick}>
              <AddIcon />
            </Button>
          ) : null}
        </div>
      </div>
      <TableContainer component={Box}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>
                {translate("resources.hos-driver-log-view.labels.country")}
              </TableCell>
              <TableCell>
                {translate("resources.hos-driver-log-view.labels.exception")}
              </TableCell>
              {permissions &&
              permissions[permissionNames.hos.logs.addException] ? (
                <TableCell></TableCell>
              ) : null}
            </TableRow>
          </TableHead>
          <TableBody>
            {record.exceptions &&
              record.exceptions.map((exception) => (
                <DriverLogExceptionViewRow
                  key={exception.id}
                  exception={exception}
                />
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
